import { AxiosResponse } from "axios";
import httpUtil from "../utils/http.util";
import { IBookingRes, IMetaData } from "../helpers/types/global";
import { MetaFormInputType } from "../pages/page-components/MetaTags/MetaForm";

class MetaService {
  create(data: MetaFormInputType): Promise<AxiosResponse<any, any>> {
    return httpUtil.post(`/metaTags/create`, data);
  }

  fetchAll(query?: string): Promise<AxiosResponse<{ data: IMetaData[] }, any>> {
    return httpUtil.get(`/metaTags${query}`);
  }

  fetchDetails(id: string): Promise<AxiosResponse<{ data: IMetaData }, any>> {
    return httpUtil.get(`/metaTags/${id}`);
  }

  update(
    id: string,
    body: MetaFormInputType
  ): Promise<AxiosResponse<any, any>> {
    return httpUtil.patch("/metaTags/update", id, body);
  }

  delete(id: string): Promise<AxiosResponse<any, any>> {
    return httpUtil.delete("/metaTags/delete", id);
  }
}
export default new MetaService();
